"use strict";

import { Application } from "../../main/application.js";

export class Time {
    static _start = Date.now();
    static _ignoreLastFrame = false;

    static get now() {
        return (Date.now() - Time._start) / 1000;
    }
    static get deltaTime() {
        if (Time._ignoreLastFrame) {
            Time._ignoreLastFrame = false;
            return 0;
        }
        
        return Application.main.ticker.elapsedMS / 1000;
    }
}